export default "__VITE_ASSET__e01ed59c__"